
export const topLinks = (branding) => [
    {
      id: "dashboard",
      "label": "Dashboard",
      "path": "/app/dashboard",
      "icon": "th-large"
    },
    {
      id: 'serviceRequests',
      "label": `${branding.text.serviceRequest}s`,
      "path": "/app/service-requests",
      "icon": "wrench"
    },
    {
      id: 'properties',
      "label": "Properties",
      "path": "/app/properties",
      "icon": "building"
    },
    {
      id:'home',
      "label": "My Home",
      "path": "/app/suites/:id",
      "icon": "home"
    },
    {
      id: 'contacts',
      "label": "Contacts",
      "path": "/app/contacts",
      "icon": "users"
    },
    {
      id:'keyContacts',
      "label": "Key Contacts",
      "path": "/app/keycontacts",
      "icon": "users"
    },
    {
      id: 'catalog',
      "label": "Catalog",
      "path": "/app/catalog",
      "icon": "boxes"
    },
    {
      id:'announcements',
      "label": "Announcements",
      "path": "/app/announcements",
      "icon": "bullhorn"
    },
    {
      id:'reporting',
      "label": "Reporting",
      "path": "/app/reporting",
      "icon": "bullhorn"
    },
    {
      id:'onboarding',
      "label": "Homeowner-onboarding",
      "path": "/app/homeowneronboarding",
      "icon": "home"
    },
    {
      id: 'inbox',
      "label": "Inbox",
      "path": "/app/inbox",
      "icon": "folder-open"
    },
    {
      id: 'downloadPdf',
      "label": "Download PDF Requests",
      "path": "/app/request",
      "icon": "cloud-download"
    }
  ]
export const bottomLinks = (branding) => [
    {
      id:'emailTemplates',
      "label": "Email Templates",
      "path": "/app/emailtemplates",
      "icon": "envelope"
    },
    {
      id: 'settings',
      "label": "Settings",
      "path": "/app/settings",
      "icon": "cog"
    },
    {
      id: 'signOut',
      "label": "Sign Out",
      "path": "/auth/sign-out",
      "icon": "sign-out"
    }
  ]

